var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.c_headers,"items":_vm.formattedRows,"disable-pagination":"","hide-default-footer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }